import { useState, useEffect } from 'react';

// Declaração do gtag para TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    gtag_report_conversion?: (url?: string) => boolean;
  }
}

export default function FloatingWhatsApp() {
  const [showPopup, setShowPopup] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    // Aguarda 2 segundos após carregar a página
    const typingTimer = setTimeout(() => {
      setShowPopup(true);
      setIsTyping(true);
    }, 2000);

    // Mostra a mensagem após 3 segundos de "digitação"
    const messageTimer = setTimeout(() => {
      setIsTyping(false);
      setShowMessage(true);
    }, 5000);

    return () => {
      clearTimeout(typingTimer);
      clearTimeout(messageTimer);
    };
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
    setShowMessage(false);
  };

  const handleWhatsAppClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
    
    window.open('https://wa.me/5512981564801?text=Olá! Gostaria de agendar uma visita e orçamento gratuito.', '_blank');
    handleClosePopup();
  };

  const handleFloatingButtonClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  return (
    <>
      {/* Pop-up de mensagem */}
      {showPopup && (
        <div className="fixed bottom-28 right-6 z-50 animate-fadeIn">
          <div className="bg-white rounded-2xl shadow-2xl p-4 max-w-xs relative">
            {/* Botão fechar */}
            <button
              onClick={handleClosePopup}
              className="absolute -top-2 -right-2 w-6 h-6 bg-gray-600 hover:bg-gray-700 text-white rounded-full flex items-center justify-center transition-colors cursor-pointer"
              aria-label="Fechar"
            >
              <i className="ri-close-line text-sm"></i>
            </button>

            {/* Cabeçalho */}
            <div className="flex items-center space-x-3 mb-3 pb-3 border-b border-gray-200">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <i className="ri-customer-service-2-line text-white text-xl"></i>
              </div>
              <div>
                <div className="font-bold text-gray-800">JB Pinturas</div>
                <div className="text-xs text-green-500 flex items-center space-x-1">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span>Online</span>
                </div>
              </div>
            </div>

            {/* Área de mensagem */}
            <div className="space-y-3">
              {/* Animação de digitação */}
              {isTyping && (
                <div className="bg-gray-100 rounded-2xl rounded-tl-none p-3 inline-block">
                  <div className="flex space-x-1">
                    <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
                    <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
                    <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
                  </div>
                </div>
              )}

              {/* Mensagem */}
              {showMessage && (
                <div className="animate-fadeIn">
                  <div className="bg-gray-100 rounded-2xl rounded-tl-none p-4 inline-block">
                    <p className="text-gray-800 text-sm leading-relaxed">
                      Olá, tudo bem? Gostaria de uma <strong>Visita e Orçamento Gratuito</strong> e Sem Compromisso, vamos agendar?
                    </p>
                  </div>
                  <div className="text-xs text-gray-400 mt-1 ml-2">Agora</div>

                  {/* Botão de resposta */}
                  <button
                    onClick={handleWhatsAppClick}
                    className="mt-3 w-full bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-lg font-semibold text-sm transition-colors flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    <span>Sim, quero agendar!</span>
                  </button>
                </div>
              )}
            </div>

            {/* Seta apontando para o botão flutuante */}
            <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white transform rotate-45"></div>
          </div>
        </div>
      )}

      {/* Botão flutuante do WhatsApp */}
      <a
        href="https://wa.me/5512981564801"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleFloatingButtonClick}
        className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:bg-green-600 transition-all transform hover:scale-110 animate-bounce cursor-pointer"
        aria-label="Fale conosco pelo WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>
    </>
  );
}
